import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { easeInOut } from '../utils/curves';
import { largeDurationMs } from '../utils/durations';
import KeyframesMotion from './keyframes-motion';
var directionMotions = {
  proportional: {
    bottom: 'translate3d(0, calc(5% + 4px), 0)',
    left: 'translate3d(calc(-5% - 4px), 0, 0)',
    right: 'translate3d(calc(5% + 4px), 0, 0)',
    top: 'translate3d(0, calc(-5% - 4px), 0)'
  },
  constant: {
    bottom: 'translate3d(0, 4px, 0)',
    left: 'translate3d(-4px, 0, 0)',
    right: 'translate3d(4px, 0, 0)',
    top: 'translate3d(0, -4px, 0)'
  }
};
var invertedDirection = {
  top: 'bottom',
  bottom: 'top',
  left: 'right',
  right: 'left'
};
export var fadeInAnimation = function fadeInAnimation(direction) {
  var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'proportional';
  return {
    from: _objectSpread({
      opacity: 0
    }, direction !== undefined && {
      transform: directionMotions[distance][direction]
    }),
    '50%': {
      opacity: 1
    },
    to: {
      transform: direction !== undefined ? 'none' : undefined
    }
  };
};
export var fadeOutAnimation = function fadeOutAnimation(direction) {
  var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'proportional';
  return {
    from: {
      opacity: 1,
      transform: direction !== undefined ? 'translate3d(0, 0, 0)' : undefined
    },
    to: _objectSpread({
      opacity: 0
    }, direction !== undefined && {
      transform: directionMotions[distance][direction]
    })
  };
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */

/**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */
var FadeIn = function FadeIn(_ref) {
  var children = _ref.children,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? largeDurationMs : _ref$duration,
      entranceDirection = _ref.entranceDirection,
      exitDirection = _ref.exitDirection,
      _ref$distance = _ref.distance,
      distance = _ref$distance === void 0 ? 'proportional' : _ref$distance,
      onFinish = _ref.onFinish,
      isPaused = _ref.isPaused;
  var invertedEntranceDirection = entranceDirection && invertedDirection[entranceDirection];
  return /*#__PURE__*/React.createElement(KeyframesMotion, {
    duration: duration,
    enteringAnimation: fadeInAnimation(entranceDirection, distance),
    exitingAnimation: fadeOutAnimation(exitDirection || invertedEntranceDirection, distance),
    animationTimingFunction: function animationTimingFunction() {
      return easeInOut;
    },
    onFinish: onFinish,
    isPaused: isPaused
  }, children);
};

export default FadeIn;